// extracted by mini-css-extract-plugin
export default {"card":"Merchants_card__LpIuA","item":"Merchants_item__ZAoBx","switch":"Merchants_switch__vK0TP","title":"Merchants_title__b4Of2"};